import EmberObject from "@ember/object"
import { inject as service } from "@ember/service"
import ENV from "../config/environment"

export default class CanonicalGroupAdapter extends EmberObject {
  @service declare ajax

  find(ids = []) {
    return this.ajax.requestFromAdapter(ENV.API_ROOT + "/canonical_groups/" + ids.join(","))
  }
}
